<template>
  <div class="innerBody">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="pageparm" class="user-search">
      <el-form-item label="搜索：">
        <el-select
          size="small"
          v-model="pageparm.status"
          placeholder="请选择订单状态"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="id" label="订单ID"> </el-table-column>
     <el-table-column prop="user" label="用户昵称">
        <template slot-scope="scope">
          {{scope.row.user.xhsName}}
        </template>
      </el-table-column>
      <el-table-column prop="user" label="用户头像">
        <template slot-scope="scope">
          <img
            :src="$store.state.fileBaseUrl + scope.row.user.avatarUrl"
            alt=""
            style="width: 100px; height: 100px"
          />
        </template>
      </el-table-column>
      <el-table-column prop="goodsName" label="商品标题"> </el-table-column>
       <el-table-column prop="goodsImage" label="商品图片">
        <template slot-scope="scope">
          <img
            :src="$store.state.fileBaseUrl + scope.row.goodsImage"
            alt=""
            style="width: 100px; height: 100px"
          />
        </template>
      </el-table-column>
      <el-table-column prop="status" label="订单来源">
        <template slot-scope="scope">
          <div>
            {{ scope.row.type == 0 ? "兑换" : "抽奖" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="当前状态">
        <template slot-scope="scope">
          <div>
            <el-tag type="danger" v-show="scope.row.status == 0"
              >待用户填写地址</el-tag
            >
            <el-tag type="danger" v-show="scope.row.status == 1">待发货</el-tag>
            <el-tag type="primary" v-show="scope.row.status == 2"
              >已发货</el-tag
            >
            <el-tag type="success" v-show="scope.row.status == 3"
              >已完成</el-tag
            >
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="下单时间"> </el-table-column>

      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
            >物流信息</el-button
          >
          <!-- 
          <el-button
            size="mini"
            type="danger"
            @click="takenOff(scope.$index, scope.row)"

            v-show="scope.row.onSale == 1"
            >下架</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="takenOn(scope.$index, scope.row)"
             v-show="scope.row.onSale == 0"
            >上架</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagtion">
      <Pagination
        v-bind:child-msg="pageparm"
        @callFather="callFather"
      ></Pagination>
    </div>

    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="40%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="收货人名称" prop="receiverName">
          {{editForm.receiverName?editForm.receiverName:"待用户填写"}}
        </el-form-item>

        <el-form-item label="收货人联系方式" prop="receiverPhone">
          {{editForm.receiverPhone?editForm.receiverPhone:"待用户填写"}}
        </el-form-item>

        <el-form-item label="收货人地址" prop="receiverAddress">
          {{editForm.receiverAddress?editForm.receiverAddress:"待用户填写"}}
        </el-form-item>



         <el-form-item label="发货订单物流号" prop="trackingNumber">
          <el-input
            size="small"
            v-model="editForm.trackingNumber"
            auto-complete="off"
            placeholder="请输入发货订单物流号"
          ></el-input>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import upImg from "../../components/upImg.vue";
import editor from "../../components/editor.vue";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        id: "",
        trackingNumber: "",
        receiverName: "",
        receiverPhone: "",
        receiverAddress: ""
      },
      rules: {
        receiverName: [{ required: true, message: "待用户填写收货人名称", trigger: "blur" }],
        receiverPhone: [{ required: true, message: "待用户填写收货人联系方式", trigger: "blur" }],
        receiverAddress: [{ required: true, message: "待用户填写收货人地址", trigger: "blur" }],
        trackingNumber: [{ required: true, message: "请输入发货物流订单号", trigger: "blur" }],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "三天后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      listData: [],
      pageparm: {
        pageNum: 1,
        pageSize: 10,
        total: 10,
        status: "",
      },
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "待填写地址",
        },
        {
          value: "1",
          label: "待发货",
        },
         {
          value: "2",
          label: "已发货",
        },
        {
          value: "3",
          label: "已完成",
        },
      ],
    };
  },
  // 注册组件
  components: {
    Pagination,
    upImg,
    editor,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.pageparm);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getdata(parameter) {
      this.loading = true;
      this.$request
        .getOrders(parameter)
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          this.listData = res.data.list;
          // // 分页赋值
          this.pageparm.pageNum = res.data.pageNum;
          this.pageparm.pageSize = res.data.pageSize;
          this.pageparm.total = res.data.total;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageNum = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.getdata(this.pageparm);
    },
    // 搜索事件
    search() {
      this.getdata(this.pageparm);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.title = "物流信息";
      this.editForm.id = row.id;
      this.editForm.receiverName = row.receiverName;
      this.editForm.receiverPhone = row.receiverPhone;
      this.editForm.receiverAddress = row.receiverAddress;
      this.editForm.trackingNumber = row.trackingNumber;
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          this.$request
            .delivery({
              orderId:this.editForm.id,
              trackingNumber:this.editForm.trackingNumber
            })
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              this.getdata(this.pageparm);
              this.$message({
                type: "success",
                message: "保存成功！",
              });
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    takenOff(index, row) {
      this.$confirm("确定要下架该商品吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request
          .offlineGoods({ id: row.id })
          .then((res) => {
            this.$message({
              type: "success",
              message: "下架成功!",
            });
            this.getdata(this.pageparm);
          })
          .catch((err) => {
            this.loading = false;
          });
      });
    },
    takenOn(index, row) {
      this.$confirm("确定要重新上架该商品吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.$request
          .onlineGoods({ id: row.id })
          .then((res) => {
            this.$message({
              type: "success",
              message: "下架成功!",
            });
            this.getdata(this.pageparm);
          })
          .catch((err) => {
            this.loading = false;
          });
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box {
  display: flex;
}
</style>





// WEBPACK FOOTER //
// src/views/orders/orders.vue